import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import NotificationsCenter from 'components/NotificationsCenter';

import { IconButton, withStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
import IconNotificationsOutlined from '@material-ui/icons/NotificationsNone';

import { makeSelectLoadingNotifications, makeSelectNotifications, makeSelectNotificationsPage } from '../selectors';
import { clearUnreadSystemNotifications, loadAccounts, loadData, loadNotifications, saveReferral } from '../actions';
import { withContext } from '../HeaderWrapper';

const styles = (theme) => ({
  iconButton: {
    width: 40,
    height: 40,
    '&:hover': {
      backgroundColor: fade(theme.palette.primary.main, 0.08),
      '& svg': {
        color: theme.palette.primary.main,
      },
    },
  },
});

// TODO delete this file once we implement Notifications in ui-next header
// Ticket to fix this TODO: https://lumahealth.clickup.com/t/867871k24
// This code were extracted as much similar as posibile from src/containers/Header/index.js -> renderNotifications method
class Notifications extends Component {
  UNSAFE_componentWillMount() {
    const { dispatchLoadHeaderInformation } = this.props;
    dispatchLoadHeaderInformation();
  }

  handleLoadMoreNotifications = () => {
    const { currentNotificationsPage, dispatchLoadMoreNotifications } = this.props;

    if (currentNotificationsPage > 0) dispatchLoadMoreNotifications(currentNotificationsPage + 1);
  };

  render() {
    const {
      currentNotificationsPage,
      loadingNotifications,
      dispatchClearUnreadNotifications,
      dispatchReferralCalledMessageAction,
      notifications,
      variant,
      classes,
    } = this.props;
    const hasMoreNotifications = !loadingNotifications && currentNotificationsPage !== 0;

    return (
      <NotificationsCenter
        renderCustomIcon={(onClick) => (
          <IconButton className={classes.iconButton} onClick={onClick}>
            <IconNotificationsOutlined />
          </IconButton>
        )}
        hasMore={hasMoreNotifications}
        notifications={notifications}
        onLoadMore={this.handleLoadMoreNotifications}
        onNotificationsCenterIconClick={dispatchClearUnreadNotifications}
        onReferralCalledMessageAction={dispatchReferralCalledMessageAction}
      />
    );
  }
}

Notifications.propTypes = {
  currentNotificationsPage: PropTypes.number,
  dispatchClearUnreadNotifications: PropTypes.func.isRequired,
  dispatchLoadHeaderInformation: PropTypes.func.isRequired,
  dispatchLoadMoreNotifications: PropTypes.func.isRequired,
  dispatchReferralCalledMessageAction: PropTypes.func.isRequired,
  loadingNotifications: PropTypes.bool,
  notifications: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  variant: PropTypes.string,
};

Notifications.defaultProps = {
  currentNotificationsPage: 1,
  loadingNotifications: false,
  notifications: false,
  variant: 'default',
};

const mapStateToProps = createStructuredSelector({
  currentNotificationsPage: makeSelectNotificationsPage(),
  loadingNotifications: makeSelectLoadingNotifications(),
  notifications: makeSelectNotifications(),
});

const mapDispatchToProps = (dispatch) => ({
  dispatchClearUnreadNotifications: () => {
    dispatch(clearUnreadSystemNotifications());
  },
  dispatchLoadHeaderInformation: () => {
    dispatch(loadAccounts());
    dispatch(loadNotifications(1));
    dispatch(loadData());
  },
  dispatchLoadMoreNotifications: (page) => {
    dispatch(loadNotifications(page));
  },
  dispatchReferralCalledMessageAction: (referral) => {
    dispatch(saveReferral(referral));
  },
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const NotificationsWrapped = withContext(Notifications);
export default compose(withConnect, withStyles(styles))(NotificationsWrapped);
